export const Helpers = (() => {
	'use strict';

	function init() {
		links();
		mobile_menu();
		smooth();
	}

	function links() {
		document.querySelectorAll('a').forEach((anchorTag) => {
			// External links
			if (
				anchorTag.href.indexOf(window.location.host) < 0 &&
				anchorTag.href.indexOf('mailto') < 0 &&
				anchorTag.href.indexOf('tel') < 0
			)
				anchorTag.setAttribute('target', '_blank');

			// Anchor links
			if (anchorTag.href.indexOf('#') === 0 && !document.getElementById(anchorTag.href.replace('#', '')))
				window.scrollTo({
					top: 0,
					behavior: 'smooth'
				});
		});
	}

	function mobile_menu() {
		const mobileTrigger = document.querySelector('.site-header__mobile-trigger');

		if (!mobileTrigger) return;

		mobileTrigger.addEventListener('click', () => {
			mobileTrigger.classList.toggle('open');
			document.body.classList.toggle('mobile-nav-open');
		});
	}

	function smooth() {
		$('a[href*="#"]')
			.not('[href="#"]')
			.not('[href="#0"]')
			.click(function (event) {
				if (
					location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') &&
					location.hostname == this.hostname
				) {
					var target = $(this.hash);
					target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
					if (target.length) {
						event.preventDefault();
						$('html, body').animate({
							scrollTop: target.offset().top
						}, 1000, function () {
							var $target = $(target);
							$target.focus();
							if ($target.is(":focus")) {
								return false;
							} else {
								$target.attr('tabindex', '-1'); 
								$target.focus(); 
							};
						});
					}
				}
			});
	}
	return {
		init: init,
	};
})();
